import React, { useState } from "react";
import LandingPage from "./components/LandingPage";
import SecondaryPage from "./components/SecondaryPage";
import Wizard from "./components/steps/Wizard";
import "./App.css";

function App() {
  const [page, changePage] = useState(0);
  const [active, changeActive] = useState(true);
  const contentStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "auto 0",
    paddingBottom: "8rem",
    textAlign: "center"
  };

  function handlePageChange(index) {
    changePage(index);
  }

  switch (page) {
    case 0:
      return (
        <div className="bigWrapper">
          <div
            style={{ height: "100vh" }}
            className={active === false ? "notActive" : ""}
          >
            <LandingPage
              contentStyle={contentStyle}
              handlePageChange={handlePageChange}
            />
          </div>

          <SecondaryPage
            changeActive={changeActive}
            contentStyle={contentStyle}
          />
        </div>
      );
    case 1:
      return (
        <div className="bigWrapper">
          <Wizard
            contentStyle={contentStyle}
            handlePageChange={handlePageChange}
          />
        </div>
      );
    default:
      return (
        <div className="bigWrapper">
          <div
            style={{ height: "100vh" }}
            className={active === false ? "notActive" : ""}
          >
            <LandingPage
              contentStyle={contentStyle}
              handlePageChange={handlePageChange}
            />
          </div>

          <SecondaryPage
            changeActive={changeActive}
            contentStyle={contentStyle}
          />
        </div>
      );
  }
}

export default App;
